export default "__VITE_ASSET__DlhzUorU__"